var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1485 9.12342C10.5394 8.86676 11.0527 9.14676 11.0527 9.61342V10.3659C11.0527 11.1068 10.4752 11.9001 9.78104 12.1334L7.92021 12.7518C7.59354 12.8626 7.06271 12.8626 6.74187 12.7518L4.88104 12.1334C4.18104 11.9001 3.60938 11.1068 3.60938 10.3659V9.60759C3.60938 9.14676 4.12271 8.86676 4.50771 9.11759L5.70938 9.89926C6.17021 10.2084 6.75354 10.3601 7.33687 10.3601C7.92021 10.3601 8.50354 10.2084 8.96438 9.89926L10.1485 9.12342Z",
    fill: "#924E27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9884 3.76914L8.49422 1.47664C7.86422 1.06247 6.82589 1.06247 6.19589 1.47664L2.68422 3.76914C1.55839 4.49831 1.55839 6.14914 2.68422 6.88414L3.61755 7.49081L6.19589 9.17081C6.82589 9.58497 7.86422 9.58497 8.49422 9.17081L11.0551 7.49081L11.8542 6.96581V8.75081C11.8542 8.98997 12.0526 9.18831 12.2917 9.18831C12.5309 9.18831 12.7292 8.98997 12.7292 8.75081V5.88081C12.9626 5.12831 12.7234 4.25331 11.9884 3.76914Z",
    fill: "#924E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.06b5cdd4bba5feff8f7f2ca1e1734b7a.svg";
export { ForwardRef as ReactComponent };